module.exports = __webpack_public_path__ + "static/media/certificate.04f32b06.png";